import React, { Component, useEffect } from 'react';
import PageTitle from "../../../Components/PageTitle";
import { SubmitBtn } from "../../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from 'react-select';
import withRouter from '../../../Utils/withRouter';
import { ConfigContext } from '../../../Context/ConfigContext'
import { currentDateAndTime, getNextMonthBeforeDate, isNumericTillGivenNumber, isValidAttendanceCycle } from '../../../Constants/constants';
import { decodeData } from '../../../Constants/constants';
import TooltipComponent from '../../../Components/TooltipComponent';

class PayrollSettings extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            payroll_setting_id: 0,
            lock_attendance: "0",
            attendace_auto_lock_date: null,
            payroll_cycle_same_as_attendance_cycle: null,
            payroll_month_cycle: null,
            attendance_input_from: null,
            consider_invalid_data_as: null,
            attendance_month_cycle: null,
            attendance_month_cycle_from_date: "01",
            attendance_month_cycle_end_date: "",
            payroll_cycle_start_date: null,
            attendace_lock_start_datetime: "",
            attendace_lock_end_datetime: "",
            attendance_month_cycle_to_date: "",
            consider_attendance_for_payroll_process: "",
            loadingList: false,
            postLoading: false,
            errors: {},
            successMsg: false,
            errorMsg: false,
            decodedData: [],
            
        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            
            this.GetPayrollSettingInfo();
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
            }
            } else {
            console.warn("Permissions not yet available. Retrying...");
            }
        }
    }
    handleNumberChange = (e, num) => {
        const { name, value } = e.target;
        if (isNumericTillGivenNumber(value, num) || value === "") {
            let date = `${new Date()?.getFullYear()}-${new Date()?.getMonth()}-${value}`;
            console.log("handleNumberChange ~ date", date);
            date = getNextMonthBeforeDate(date);
            let nextDay = date?.split("-")[2];
            this.setState((prevState) => ({
                [name]: value,
                attendance_month_cycle_to_date: nextDay || "",
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
    }
    handleMonthCycleDate = (name, value) => {
        if(name !== "attendance_month_cycle_to_date"){
            let date = `${currentDateAndTime()?.split(" ")[0]?.split("-")?.[0]}-${currentDateAndTime()?.split(" ")[0]?.split("-")?.[1]}-${value}`;
            console.log("handleMonthCycleDate 1",date, value);
            date = getNextMonthBeforeDate(date);
            console.log("handleMonthCycleDate 2",date, value);
            let nextDay = date?.split("-")[2];
            this.setState((prevState) => ({
                [name]: value,
                attendance_month_cycle_to_date: nextDay || "",
                payroll_cycle_start_date: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else{
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        
    }
    handleDateTimeChange = (e, name) => {
        this.setState((prevState) => ({
            [name]: e.target.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    GetAttendanceSettingInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Attendance/GetAttendanceSettingInfo`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                if (this.state.payroll_cycle_same_as_attendance_cycle == '1') {
                    this.setState(
                        {
                            attendance_month_cycle: data[0]?.attendance_month_cycle || "1",
                            attendance_month_cycle_from_date: data[0]?.attendance_month_cycle_start_date || "01",
                            attendance_month_cycle_to_date: data[0]?.attendance_month_cycle_end_date,
                        }
                    )
                }

            }
        });
    }

    GetPayrollSettingInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Payrolls/GetPayrollGeneralSetting`, { headers }).then((response) => {
            const { payroll_general_setting, success } = response.data;
            // console.log('GetPayrollSettingInfo ~ response', payroll_general_setting);
            if (success === true) {
                // console.log("payroll_general_setting[0]?.payroll_cycle_same_as_attendance_cycle", payroll_general_setting[0]?.payroll_cycle_same_as_attendance_cycle);
                // console.log("payroll_general_setting[0]?.payroll_cycle_end_date", payroll_general_setting[0]?.payroll_cycle_end_date);

                this.setState(
                    {
                        payroll_setting_id: payroll_general_setting[0]?.payroll_setting_id,
                        lock_attendance: payroll_general_setting[0]?.lock_attendance || "0",
                        attendace_auto_lock_date: payroll_general_setting[0]?.attendace_auto_lock_date,
                        payroll_cycle_same_as_attendance_cycle: payroll_general_setting[0]?.payroll_cycle_same_as_attendance_cycle,
                        attendance_input_from: payroll_general_setting[0]?.attendance_input_from,
                        payroll_cycle_start_date: payroll_general_setting[0]?.payroll_cycle_start_date,
                        consider_invalid_payroll_general_setting_as: payroll_general_setting[0]?.consider_invalid_payroll_general_setting_as,
                        attendance_month_cycle: payroll_general_setting[0]?.payroll_month_cycle,
                        attendance_month_cycle_from_date: payroll_general_setting[0]?.payroll_cycle_start_date,
                        attendace_lock_start_datetime: payroll_general_setting[0]?.attendace_lock_start_datetime,
                        attendace_lock_end_datetime: payroll_general_setting[0]?.attendace_lock_end_datetime,
                        attendance_month_cycle_to_date: payroll_general_setting[0]?.payroll_cycle_end_date,
                        consider_attendance_for_payroll_process: payroll_general_setting[0]?.consider_attendance_for_payroll_process,
                    },
                    ()=>{
                        if(payroll_general_setting[0]?.payroll_cycle_same_as_attendance_cycle==="1"){
                            this.GetAttendanceSettingInfo();
                        }
                        // console.log("attendance_month_cycle_from_date", this.state.attendance_month_cycle_from_date)
                        // console.log("attendance_month_cycle_to_date", this.state.attendance_month_cycle_to_date)
                    }
                )
                // this.handleMonthCycleDate('attendance_month_cycle_from_date', payroll_general_setting[0]?.payroll_cycle_start_date);
            }
        });
    }



    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        console.log("handleSubmit errors",errors);
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        this.setState({ postLoading: true });
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        // console.log("this.state.payroll_cycle_same_as_attendance_cycle , this.state.payroll_month_cycle , this.state.attendance_month_cycle", this.state.payroll_cycle_same_as_attendance_cycle, this.state.payroll_month_cycle, this.state.attendance_month_cycle)
        const formData = {
            payroll_setting_id: this.state.payroll_setting_id,
            lock_attendance: this.state.lock_attendance || "0",
            attendace_auto_lock_date: this.state.attendace_auto_lock_date,
            payroll_cycle_same_as_attendance_cycle: this.state.payroll_cycle_same_as_attendance_cycle,
            payroll_month_cycle: this.state.payroll_cycle_same_as_attendance_cycle == '0' ? this.state.payroll_month_cycle || this.state.attendance_month_cycle : this.state.attendance_month_cycle,
            payroll_cycle_start_date: this.state.payroll_cycle_start_date,
            payroll_cycle_end_date: this.state.attendance_month_cycle_to_date,
            attendance_input_from: this.state.attendance_input_from,
            consider_invalid_data_as: this.state.consider_invalid_data_as,
            attendance_month_cycle: this.state.attendance_month_cycle,
            attendance_month_cycle_from_date: this.state.attendance_month_cycle_from_date,
            attendace_lock_start_datetime: this.state.attendace_lock_start_datetime,
            attendace_lock_end_datetime: this.state.attendace_lock_end_datetime,
            attendance_month_cycle_to_date: this.state.attendance_month_cycle_to_date,
            consider_attendance_for_payroll_process: this.state.consider_attendance_for_payroll_process,
            date: currentDateAndTime(),
        }
        console.log("this.state.payroll_cycle_end_date", this.state.payroll_cycle_start_date, formData.attendance_month_cycle_to_date);
        axios.post(`${apiURL}Payrolls/CreatePayrollGeneralSetting`, formData, { headers }).then((response) => {
            const { success } = response.data;
            if (success === true) {
                // this.resetForm();
                this.GetAttendanceSettingInfo();
                this.GetPayrollSettingInfo();
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true,  
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {               
                        // Call your function after the alert is closed
                    }
                });
            } else {
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true,  // Show OK button
                    allowOutsideClick: false,
                })
            }
            this.setState({ postLoading: false });

        }).catch((e) => {
            Swal.fire({
                title: `<strong>'Failed'</strong>`,
                text: "Opps!! Something went wrong.",
                icon: 'error',
                showConfirmButton: true,  // Show OK button
                allowOutsideClick: false,
            });
            this.setState({ postLoading: false });
        })
    };

    resetForm = () => {
        this.setState({
            payroll_setting_id: 0,
            loadingList: false,
            postLoading: false,
            errors: {},
        });
    };

    validateForm() {
        const errors = {};

        if (!this.state.attendace_lock_start_datetime && this.state.lock_attendance === '1') {
            errors.attendace_lock_start_datetime = 'Please select the start time';
        }
        // if (!this.state.attendace_lock_end_datetime && this.state.lock_attendance === '1') {
        //     errors.attendace_lock_end_datetime = 'Please select the end date & time';
        // }
        if (this.state.attendance_month_cycle==="2" && !this.state.attendance_month_cycle_from_date) {
            errors.attendance_month_cycle_from_date = 'Month cycle from date cannot be empty';
        }
        if (this.state.attendance_month_cycle==="2" && !this.state.attendance_month_cycle_to_date) {
            errors.attendance_month_cycle_to_date = 'Month cycle to date cannot be empty';
        }
        if (this.state.attendance_month_cycle==="2" && 
            this.state.attendance_month_cycle_from_date && 
            this.state.attendance_month_cycle_to_date) {
                console.log("this.state.attendance_month_cycle_from_date,this.state.attendance_month_cycle_to_date",this.state.attendance_month_cycle_from_date,this.state.attendance_month_cycle_to_date);
                console.log(isValidAttendanceCycle(this.state.attendance_month_cycle_from_date,this.state.attendance_month_cycle_to_date));
                const {isTrue, days}=isValidAttendanceCycle(this.state.attendance_month_cycle_from_date,this.state.attendance_month_cycle_to_date);
                if(!isTrue){
                    if(days < 2){
                        errors.attendance_month_cycle_to_date = 'Month cycle days are less than 2';
                    }
                    else if(days >31){
                        errors.attendance_month_cycle_to_date = 'Month cycle days are more than 31';
                    }
                }
            
        }
        return errors;
    }

    handleRadioChange = (name, value) => {
        if (name === 'payroll_cycle_same_as_attendance_cycle' && value === '1') {
            this.GetAttendanceSettingInfo();
        }
        if (name === 'payroll_cycle_same_as_attendance_cycle' && value === '0') {
            //this.GetPayrollSettingInfo();
            this.setState({ payroll_cycle_start_date: this.state.attendance_month_cycle_from_date, payroll_month_cycle: this.state.attendance_month_cycle })
        }
        if (name === "attendance_month_cycle") {
            this.setState({ payroll_month_cycle: value })
        }

        if (name === "attendance_month_cycle" && value === "1") {
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else {
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }

        // console.log(name, value);
    };


    render() {
        const { errors } = this.state;
        const  monthStartDates = [
            { value: 1, label: "01" },
            { value: 2, label: "02" },
            { value: 3, label: "03" },
            { value: 4, label: "04" },
            { value: 5, label: "05" },
            { value: 6, label: "06" },
            { value: 7, label: "07" },
            { value: 8, label: "08" },
            { value: 9, label: "09" },
            { value: 10, label: "10" },
            { value: 11, label: "11" },
            { value: 12, label: "12" },
            { value: 13, label: "13" },
            { value: 14, label: "14" },
            { value: 15, label: "15" },
            { value: 16, label: "16" },
            { value: 17, label: "17" },
            { value: 18, label: "18" },
            { value: 19, label: "19" },
            { value: 20, label: "20" },
            { value: 21, label: "21" },
            { value: 22, label: "22" },
            { value: 23, label: "23" },
            { value: 24, label: "24" },
            { value: 25, label: "25" },
            { value: 26, label: "26" },
            { value: 27, label: "27" },
            { value: 28, label: "28" },
            { value: 29, label: "29" },
            { value: 30, label: "30" },
            { value: 31, label: "31" },
        ]
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Payroll General Settings`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Payroll General Settings</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form className="row settings-form">
                                                    <div className="form-check col-md-6 ">
                                                        <input
                                                            type="checkbox"
                                                            id="lock_attendance"
                                                            name="lock_attendance"
                                                            value="1"
                                                            checked={this.state.lock_attendance === "1"}
                                                            onChange={(e) =>
                                                                this.handleRadioChange(
                                                                    "lock_attendance",
                                                                    e.target.checked ? "1" : "0"
                                                                )
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="lock_attendance">
                                                            Do You want to Auto Lock the Attendance & Leave Module on specific Date & Time
                                                        </label>

                                                        {/* <label>{this.state.lock_attendance === '1' ? '' : 'Update the Date & Time'}</label> <br /> */}

                                                        {this.state.lock_attendance === '1' ? <>
                                                            <div className=" mt-3">
                                                                <div class="form-check form-check-inline mx-4">
                                                                    <input
                                                                        type="radio"
                                                                        id="attendace_auto_lock_date1"
                                                                        name="attendace_auto_lock_date1"
                                                                        value='1'
                                                                        checked={this.state.attendace_auto_lock_date === '1'}
                                                                        onChange={() => this.handleRadioChange('attendace_auto_lock_date', '1')}
                                                                        class="form-check-input"
                                                                    // disabled={!this.state.company_location_shift_id}
                                                                    />
                                                                    <label for="attendace_auto_lock_date1" class="form-check-label">1 Day after the End of Attendance Cycle
                                                                    <span className="ms-1">
                                                                    <TooltipComponent 
                                                                    name="The attendance and leave module will be locked automatically one day after the attendance cycle ends. You can also set a specific time for the lock."                                                                     
                                                                     position="top"
                                                                    >
                                                                    <i 
                                                                    className="ri-information-line" 
                                                                    style={{ cursor: "pointer", color: "#007bff" }} 
                                                                    aria-label="More info"
                                                                    ></i>
                                                                    </TooltipComponent>
                                                                    </span>
                                                                    </label>
                                                                </div> <br />
                                                                <div class="form-check form-check-inline mx-4">
                                                                    <input
                                                                        type="radio"
                                                                        id="attendace_auto_lock_date2"
                                                                        name="attendace_auto_lock_date2"
                                                                        value="2"
                                                                        checked={this.state.attendace_auto_lock_date === '2'}
                                                                        onChange={() => this.handleRadioChange('attendace_auto_lock_date', '2')}
                                                                        class="form-check-input"
                                                                    // disabled={!this.state.company_location_shift_id}
                                                                    />
                                                                    <label for="attendace_auto_lock_date2" class="form-check-label">Same Day of the End of Attendance Cycle
                                                                    <span className="ms-1">
                                                                    <TooltipComponent 
                                                                    name="The attendance and leave module will be locked automatically on the same day the attendance cycle ends. You can also set a specific time for the lock."                                                                     
                                                                     position="top"
                                                                    >
                                                                    <i 
                                                                    className="ri-information-line" 
                                                                    style={{ cursor: "pointer", color: "#007bff" }} 
                                                                    aria-label="More info"
                                                                    ></i>
                                                                    </TooltipComponent>
                                                                    </span>
                                                                    </label>
                                                                </div> <br />
                                                                {/* <div class="form-check form-check-inline mx-4">
                                                                <input
                                                                    type="radio"
                                                                    id="attendace_auto_lock_date3"
                                                                    name="attendace_auto_lock_date3"
                                                                    value="2"
                                                                    checked={this.state.attendace_auto_lock_date === '3'}
                                                                    onChange={() => this.handleRadioChange('attendace_auto_lock_date', '3')}
                                                                    class="form-check-input"
                                                                // disabled={!this.state.company_location_shift_id}
                                                                />
                                                                <label for="attendace_auto_lock_date3" class="form-check-label">1 Day after the End Payroll Cycle</label>
                                                            </div> <br />
                                                            <div class="form-check form-check-inline mx-4">
                                                                <input
                                                                    type="radio"
                                                                    id="attendace_auto_lock_date4"
                                                                    name="attendace_auto_lock_date4"
                                                                    value="2"
                                                                    checked={this.state.attendace_auto_lock_date === '4'}
                                                                    onChange={() => this.handleRadioChange('attendace_auto_lock_date', '4')}
                                                                    class="form-check-input"
                                                                // disabled={!this.state.company_location_shift_id}
                                                                />
                                                                <label for="attendace_auto_lock_date4" class="form-check-label">On the Day of the End of Payroll Cycle</label>
                                                            </div>  */}
                                                                <br />
                                                                <div className='row p-1'>
                                                                    <div className="col-md-6">
                                                                        <label>Lock Start Time</label>
                                                                        <input
                                                                            type="time"
                                                                            className={`form-control ${errors.attendace_lock_start_datetime ? 'is-invalid' : ''}`}
                                                                            name="attendace_lock_start_datetime"
                                                                            value={this.state.attendace_lock_start_datetime}
                                                                            onChange={(e) => this.handleDateTimeChange(e, "attendace_lock_start_datetime")}
                                                                        />
                                                                        {errors.attendace_lock_start_datetime && <div className="text-danger">{errors.attendace_lock_start_datetime}</div>}
                                                                    </div>
                                                                    {/* <div className="col-md-6">
                                                                        <label>Lock End Time</label>
                                                                        <input
                                                                            type="time"
                                                                            name="attendace_lock_end_datetime"
                                                                            className={`form-control ${errors.attendace_lock_end_datetime ? 'is-invalid' : ''}`}
                                                                            value={this.state.attendace_lock_end_datetime}
                                                                            onChange={(e) => this.handleDateTimeChange(e, "attendace_lock_end_datetime")}
                                                                        />
                                                                        {errors.attendace_lock_end_datetime && <div className="text-danger">{errors.attendace_lock_end_datetime}</div>}
                                                                    </div> */}
                                                                </div>
                                                            </div>
                                                        </> :
                                                            null
                                                        }
                                                    </div>
                                                    {/* <div className="col-md-6 mt-4 settings-section">
                                                        <div>
                                                            <label for="lock_attendance" class="form-label">Do You want to lock the Attendance & Leave Module on specific Date & Time</label>
                                                        </div>
                                                        <div class="form-check form-check-inline mt-2 mx-4">
                                                            <input
                                                                type="radio"
                                                                id="lock_attendance1"
                                                                name="lock_attendance"
                                                                value='1'
                                                                checked={this.state.lock_attendance === '1'}
                                                                onChange={() => this.handleRadioChange('lock_attendance', '1')}
                                                                class="form-check-input"
                                                            />
                                                            <label for="lock_attendance1" class="form-check-label">Yes</label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="lock_attendance0"
                                                                name="lock_attendance"
                                                                value="0"
                                                                checked={this.state.lock_attendance === '0'}
                                                                onChange={() => this.handleRadioChange('lock_attendance', '0')}
                                                                class="form-check-input"
                                                            />
                                                            <label for="lock_attendance0" class="form-check-label">No</label>
                                                        </div>
                                                    </div> */}
                                                    <div className="col-md-6 settings-section">
                                                        <div>
                                                            <label>Do you follow Payroll Cycle Dates same as Attendance & Leave Cycle</label>
                                                        </div>
                                                        <div class="form-check form-check-inline mt-2 mx-4">
                                                            <input
                                                                type="radio"
                                                                id="payroll_cycle_same_as_attendance_cycle1"
                                                                name="payroll_cycle_same_as_attendance_cycle"
                                                                value='1'
                                                                checked={this.state.payroll_cycle_same_as_attendance_cycle === '1'}
                                                                onChange={() => this.handleRadioChange('payroll_cycle_same_as_attendance_cycle', '1')}
                                                                class="form-check-input"
                                                            />
                                                            <label for="payroll_cycle_same_as_attendance_cycle1" class="form-check-label">Yes</label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="payroll_cycle_same_as_attendance_cycle0"
                                                                name="payroll_cycle_same_as_attendance_cycle"
                                                                value="0"
                                                                checked={this.state.payroll_cycle_same_as_attendance_cycle === '0'}
                                                                onChange={() => this.handleRadioChange('payroll_cycle_same_as_attendance_cycle', '0')}
                                                                class="form-check-input"
                                                            />
                                                            <label for="payroll_cycle_same_as_attendance_cycle0" class="form-check-label">No</label>
                                                        </div>
                                                        <div className=" mx-3 settings-section">
                                                            <label>Does your Payroll Cycle Starts at the beginning of the Month</label> <br />
                                                            <div class="form-check form-check-inline mt-2 mx-4">
                                                                <input
                                                                    type="radio"
                                                                    id="attendance_month_cycle1"
                                                                    name="attendance_month_cycle1"
                                                                    value='1'
                                                                    checked={this.state.attendance_month_cycle === '1'}
                                                                    onChange={() => this.handleRadioChange('attendance_month_cycle', '1')}
                                                                    class="form-check-input"
                                                                    disabled={this.state.payroll_cycle_same_as_attendance_cycle === "1"}
                                                                />
                                                                <label for="attendance_month_cycle1" class="form-check-label">Month start date to Month end date</label>
                                                            </div> <br />
                                                            <div class="form-check form-check-inline mx-4">
                                                                <input
                                                                    type="radio"
                                                                    id="attendance_month_cycle2"
                                                                    name="attendance_month_cycle2"
                                                                    value="2"
                                                                    checked={this.state.attendance_month_cycle === '2'}
                                                                    onChange={() => this.handleRadioChange('attendance_month_cycle', '2')}
                                                                    class="form-check-input"
                                                                    disabled={this.state.payroll_cycle_same_as_attendance_cycle === "1"}
                                                                />
                                                                <label for="attendance_month_cycle2" class="form-check-label">Select Custom Date</label>
                                                            </div> <br />
                                                            {this.state.attendance_month_cycle === "2" && (
                                                                <div className='mx-4 mt-2'>
                                                                    <label>Monthly Attendance Cycle Date <span className='text-muted small'>(Max input date limit is 28)</span></label>
                                                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem" }}>
                                                                        <div>
                                                                            <label>From Date</label><br />
                                                                            <Select
                                                                                onChange={(selectedOption) => { this.handleMonthCycleDate("attendance_month_cycle_from_date", selectedOption?.label) }}
                                                                                placeholder="Select From Date"
                                                                                required
                                                                                className={``}
                                                                                options={monthStartDates}
                                                                                value={this.state.attendance_month_cycle_from_date ? monthStartDates?.find(row => row?.label === this.state.attendance_month_cycle_from_date) : null}
                                                                                isDisabled={this.state.payroll_cycle_same_as_attendance_cycle === "1"}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <label>To Date</label><br />
                                                                            <Select
                                                                                onChange={(selectedOption) => { this.handleMonthCycleDate("attendance_month_cycle_to_date", selectedOption?.label) }}
                                                                                isDisabled={!this.state.attendance_month_cycle_from_date}
                                                                                placeholder="Select To Date"
                                                                                required
                                                                                className={``}
                                                                                options={monthStartDates}
                                                                                value={this.state.attendance_month_cycle_to_date ? monthStartDates?.find(row => row?.label == this.state.attendance_month_cycle_to_date) : null}
                                                                            />
                                                                        </div>
                                                                        {/* <div>
                                                                            <label>To Date</label><br />
                                                                            <input
                                                                                type="text"
                                                                                className={`form-control col-md-3 ${errors.attendance_month_cycle_to_date ? 'is-invalid' : ''}`}
                                                                                // disabled={!this.state.company_location_shift_id}
                                                                                name="attendance_month_cycle_to_date"
                                                                                value={this.state.attendance_month_cycle_to_date}
                                                                                placeholder="Enter To Date"
                                                                                onChange={(e) => this.handleNumberChange(e, 28)}
                                                                                disabled
                                                                            />
                                                                        </div> */}
                                                                        

                                                                    </div>
                                                                    {errors.attendance_month_cycle_from_date || errors.attendance_month_cycle_to_date && <div className="text-danger">{errors.attendance_month_cycle_from_date || errors.attendance_month_cycle_to_date}</div>}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 mt-4 settings-section" style={this.state.attendance_input_from === '1' ? { borderTopLeftRadius: "8px", borderBottomLeftRadius: "8px", padding: '4px' } : { backgroundColor: "white" }}>
                                                        <div>
                                                            <label for="attendance_input_from" class="form-label">How do you want to Input the Attendance Data?</label>
                                                        </div>
                                                        <div class="form-check form-check-inline mt-2 mx-4">
                                                            <input
                                                                type="radio"
                                                                id="attendance_input_from1"
                                                                name="attendance_input_from"
                                                                value='1'
                                                                checked={this.state.attendance_input_from == '1'}
                                                                onChange={() => this.handleRadioChange('attendance_input_from', '1')}
                                                                class="form-check-input"
                                                            // disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label for="attendance_input_from1" class="form-check-label">Through Attendance Module
                                                            <span className="ms-1">
                                                                <TooltipComponent 
                                                                name="This option takes attendance data directly from the system"                                                                     
                                                                position="top"
                                                                >
                                                                <i 
                                                                className="ri-information-line" 
                                                                style={{ cursor: "pointer", color: "#007bff" }} 
                                                                aria-label="More info"
                                                                ></i>
                                                                </TooltipComponent>
                                                            </span>
                                                            </label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="attendance_input_from2"
                                                                name="attendance_input_from"
                                                                value="2"
                                                                checked={this.state.attendance_input_from == '2'}
                                                                onChange={() => this.handleRadioChange('attendance_input_from', '2')}
                                                                class="form-check-input"
                                                            // disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label for="attendance_input_from2" class="form-check-label">Through Manual Upload
                                                            <span className="ms-1">
                                                                <TooltipComponent 
                                                                name=" This option takes attendance data from an Excel file."                                                                     
                                                                position="top"
                                                                >
                                                                <i 
                                                                className="ri-information-line" 
                                                                style={{ cursor: "pointer", color: "#007bff" }} 
                                                                aria-label="More info"
                                                                ></i>
                                                                </TooltipComponent>
                                                            </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mt-4 settings-section">
                                                        <div>
                                                            <label>Do you want to consider the attendance for payroll process</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="consider_attendance_for_payroll_process_1"
                                                                name="consider_attendance_for_payroll_process_1"
                                                                value="1"
                                                                checked={this.state.consider_attendance_for_payroll_process === "1"}
                                                                onChange={() => this.handleRadioChange("consider_attendance_for_payroll_process", "1")}
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="consider_attendance_for_payroll_process_1"
                                                                className="form-check-label"
                                                            >
                                                                Yes
                                                            </label>
                                                            {this.state.consider_attendance_for_payroll_process === "1" && (
                                                                <small style={{ marginLeft: "0.5rem" }} className='text-danger'>( Follow the attendance run process to determine the payable days.)</small>

                                                            )}
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="consider_attendance_for_payroll_process_0"
                                                                name="consider_attendance_for_payroll_process_0"
                                                                value="0"
                                                                checked={this.state.consider_attendance_for_payroll_process === "0"}
                                                                onChange={() => this.handleRadioChange("consider_attendance_for_payroll_process", "0")}
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="consider_attendance_for_payroll_process_0"
                                                                className="form-check-label"
                                                            >
                                                                No
                                                            </label>
                                                            {this.state.consider_attendance_for_payroll_process === "0" && (
                                                                <small style={{ marginLeft: "0.5rem" }} className='text-danger'>( Do not process the attendance run module consider only the monthly leave module.)</small>

                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* <div className="col-md-6 mt-4 " style={this.state.attendance_input_from === '1' ? { backgroundColor: "#fafafa", borderTopLeftRadius: "8px", borderBottomLeftRadius: "8px", padding: '4px' } : { backgroundColor: "white" }}>
                                                        {this.state.attendance_input_from === '1' && <>
                                                            <label>How do you want to Consider Invalid Data?
                                                            </label><br />

                                                            <div class="form-check form-check-inline mt-2 mx-4">
                                                                <input
                                                                    type="radio"
                                                                    id="consider_invalid_data_as1"
                                                                    name="consider_invalid_data_as1"
                                                                    value='1'
                                                                    checked={this.state.consider_invalid_data_as === '1'}
                                                                    onChange={() => this.handleRadioChange('consider_invalid_data_as', '1')}
                                                                    class="form-check-input"
                                                                // disabled={!this.state.company_location_shift_id}
                                                                />
                                                                <label for="consider_invalid_data_as1" class="form-check-label">Consider LOP</label>
                                                            </div> <br />
                                                            <div class="form-check form-check-inline mx-4">
                                                                <input
                                                                    type="radio"
                                                                    id="consider_invalid_data_as2"
                                                                    name="consider_invalid_data_as2"
                                                                    value="2"
                                                                    checked={this.state.consider_invalid_data_as === '2'}
                                                                    onChange={() => this.handleRadioChange('consider_invalid_data_as', '2')}
                                                                    class="form-check-input"
                                                                // disabled={!this.state.company_location_shift_id}
                                                                />
                                                                <label for="consider_invalid_data_as2" class="form-check-label">Consider HD</label>
                                                            </div> <br />
                                                            <div class="form-check form-check-inline mx-4">
                                                                <input
                                                                    type="radio"
                                                                    id="consider_invalid_data_as3"
                                                                    name="consider_invalid_data_as3"
                                                                    value="2"
                                                                    checked={this.state.consider_invalid_data_as === '3'}
                                                                    onChange={() => this.handleRadioChange('consider_invalid_data_as', '3')}
                                                                    class="form-check-input"
                                                                // disabled={!this.state.company_location_shift_id}
                                                                />
                                                                <label for="consider_invalid_data_as3" class="form-check-label">Check Back and allow regularization</label>
                                                            </div> <br />
                                                        </>}
                                                    </div> */}

                                                    <div className=' position-relative'>
                                                        {this.state.successMsg ?
                                                            <div className=" position-relative alert alert-success mt-3" role="alert">
                                                                {this.state.successMsg} <span onClick={() => { this.setState({ successMsg: false }) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                            </div>
                                                            : null
                                                        }
                                                        {this.state.errorMsg ?
                                                            <div className=" position-relative alert alert-danger mt-3" role="alert">
                                                                {this.state.errorMsg} <span onClick={() => { this.setState({ errorMsg: false }) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                            </div> : null
                                                        }
                                                        { this.state.decodedData?.includes(3) && (
                                                        <div style={{ marginTop: "30px", marginLeft: 'Auto' }}>
                                                            {!this.state.postLoading ?
                                                                <button
                                                                    onClick={(e) => this.handleSubmit(e)}
                                                                    className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                                                >
                                                                    <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                                    {this.state.payroll_setting_id ? "Update" : "Save"}
                                                                </button> :
                                                                <button disabled={true}
                                                                    className={`btn btn-primary btn-label waves-effect right waves-light float-right`}>
                                                                    <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                                    Loading...
                                                                </button>                                                           
                                                            }
                                                        </div>)}
                                                    </div>

                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        )
    };
}
export default withRouter(PayrollSettings);
